//#region src/modules/core/utils/functions.ts
var isNotEmptyOrNull = (string) => Boolean(string);
var decodeBase64 = (base64) => {
	if (!base64) return null;
	try {
		return window.atob(base64);
	} catch {
		return null;
	}
};
//#endregion
export { decodeBase64, isNotEmptyOrNull };
